<template lang="pug">
div
  section.hero.is-info.is-bold.is-small
    .hero-body
      .level
        .level-left
          .title.is-1 Index Funds Holdings
        .level-right
          honeymoney_block.is-pulled-right.is-hidden-mobile
  section.section
    //- .message.is-warning.content: .message-body
    //-   .columns
    //-     .column
    //-       p Ever wondered how much you have:
    //-       //- vue-typer(
    //-       //-   :text='["How much do you have in Apple or Facebook?","What is your share of Tesla?","Google sounds cool, do you own it?","What about Real Estate?",""]'
    //-       //-   :repeat='Infinity'
    //-       //-   initial-action='typing'
    //-       //-   :pre-type-delay='50'
    //-       //-   :type-delay='50'
    //-       //-   :pre-erase-delay='2000'
    //-       //-   :erase-delay='250'
    //-       //-   erase-style='select-all'
    //-       //-   :erase-on-complete='false'
    //-       //-   caret-animation='blink'
    //-       //- )
    //-       ul
    //-         li in your favourite auto maker?
    //-         li in all European countries?
    //-         li in Real Estate funds?
    //-         li in all fast food of the world?
    //-     .column

    .box: portfolio

    .columns: .column
      .subtitle.is-3.has-text-centered
        | You have
        |   <b>{{ total_owned | rounded_currency }}</b> ({{ (total_owned / STOCKED.portfolio_size * 100) | number }}% of portfolio) in {{ filtered_holdings.length | rounded_number }} holdings


    holdings_stats(:holdings='filtered_holdings', :all_countries='STOCKED.all_countries')
      template(slot='countries_filter')
        //- | {{ filter.countries }}
        multiselect(v-model='filter.countries', :options='STOCKED.all_countries', :multiple='true', :hide-selected='true', placeholder='Filter by countries', :show-labels='false')
          template(slot="clear", slot-scope="props")
            div.multiselect__clear(v-if="filter.countries.length" @mousedown.prevent.stop="filter.countries = []")
      template(slot='sectors_filter')
        //- | {{ filter.sectors }}
        multiselect(v-model='filter.sectors', :options='STOCKED.all_sectors', :multiple='true', :hide-selected='true', placeholder='Filter by sectors', :show-labels='false') //-, :close-on-select='false'
          template(slot="clear", slot-scope="props")
            div.multiselect__clear(v-if="filter.sectors.length" @mousedown.prevent.stop="filter.sectors = []")
      template(slot='sample_filters')
        .subtitle.is-5 Sample Filters:
        .predefined_filters
          a(@click='setIT')
            span.icon.is-medium(style='font-size: 1.5em') 💻
            | Computers-Internet-Software
          | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          a(@click='setRE')
            span.icon.is-medium(style='font-size: 1.5em') 🏢
            | Real Estate
          | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          a(@click='setShopping')
            span.icon.is-medium(style='font-size: 1.5em') 🛍
            | Shopping
          | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          a(@click='setSin')
            span.icon.is-medium(style='font-size: 2em') 🚬
            | Tobacco-Alcohol-Gambling
          | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          a(@click='setFinance')
            span.icon.is-medium(style='font-size: 1.5em') 💰
            | Finance
          | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          a(@click='setAuto')
            span.icon.is-medium(style='font-size: 1.5em') 🚗
            | Auto
          div(v-if='STOCKED.all_countries.length > 2')
            a(@click='setG7')
              span.icon.is-medium(style='font-size: 1.5em') 🇺🇸
              | G7 countries
            | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            a(@click='setEU')
              span.icon.is-medium(style='font-size: 1.5em') 🇪🇺
              | European countries
            | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            a(@click='setBRICS')
              span.icon.is-medium(style='font-size: 1.5em') 🇨🇳
              | BRICS countries
            | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            a(@click='setAfricaAndME')
              span.icon.is-medium(style='font-size: 1.5em') 🌍
              | Africa & Middle East
            | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            a(@click='setSEAsia')
              span.icon.is-medium(style='font-size: 1.5em') 🌏
              | South East Asia

    .columns
      .column.is-block-mobile(style='display: none;')
        input.input(type='text' v-model='filter.search' placeholder='Search by name')

    .columns: .column
      holdings_table(:holdings="limited_holdings", :search_term='filter.search')
        template(slot='search')
          input.input(type='text' v-model.trim='filter.search' placeholder='Filter by name')
      .has-text-centered
        span {{ limited_holdings.length }} of {{ filtered_holdings.length | rounded_number }}
        br
        a.button.is-info.is-small(@click="loadMore" v-if="limited_holdings.length < filtered_holdings.length") display more »
</template>


<script>
const StocksFilter = require('./filter.js').default

export default {
  name: 'Stocked',
  components: {
    holdings_table: require('./../components/holdings_table.vue').default,
    holdings_stats: require('./../components/holdings_stats.vue').default,
    portfolio: require('./../components/portfolio.vue').default,
    honeymoney_block: require('./../components/honeymoney_block.vue').default,
    'vue-typer': require('vue-typer').VueTyper
  },
  data() {
    return {
      filter: {
        search: (this.$route.query.search || ''),
        countries: _.compact((this.$route.query.countries || '').split(',')),
        sectors: _.compact((this.$route.query.sectors || '').split(',')),
      },
      STOCKED,
      holdings_limit: 50,
      stats: {}
    }
  },
  computed: {
    filtered_holdings() {
      return StocksFilter.find_holdings(this.filter, STOCKED.all_holdings)
    },
    limited_holdings() {
      let result = this.filtered_holdings
      if (result.length > this.holdings_limit) {
        result = result.slice(0, this.holdings_limit)
      }
      return result
    },
    total_owned() { return Math.min(_.sumBy(this.filtered_holdings, 'owned'), STOCKED.portfolio_size) }
  },
  mounted() {
    this.saveFilterToURL()
  },
  methods: {
    loadMore() {
      mixpanel.track('loaded more', { current: this.holdings_limit })
      this.holdings_limit += 50
    },
    saveFilterToURL() {
      this.$watch('filter', (() => {
        const query = _.clone(this.$route.query)
        query.search = this.filter.search
        query.countries = this.filter.countries.join(',')
        query.sectors = this.filter.sectors.join(',')
        this.$router.replace({
          name: this.$router.currentRoute.name, query: _.omitBy(query, _.isEmpty),
        })
      }), { deep: true })
    },
    setSin() {
      mixpanel.track('set filter', { name: 'Sin' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Tobacco', 'Brewers', 'Gambling', 'Distillers - Vintners']
    },
    setIT() {
      mixpanel.track('set filter', { name: 'IT' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Computer Hardware', 'Software', 'Internet', 'Semiconductors', 'Consumer Digital Services', 'Telecommunications Services', 'Computer Services']
    },
    setRE() {
      mixpanel.track('set filter', { name: 'RE' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Diversified REITs', 'Hotel - Lodging REITs', 'Industrial - Office REITs', 'Mortgage REITs', 'Residential REITs', 'Retail REITs', 'Specialty REITs', 'Real Estate Holding - Development', 'Real Estate Services', 'Mortgage Finance']
    },
    setShopping() {
      mixpanel.track('set filter', { name: 'Shopping' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Apparel Retailers', 'Broadline Retailers', 'Home Improvement Retailers', 'Specialty Retailers', 'Food Retailers - Wholesalers', 'Drug Retailers', 'Clothing - Accessories', 'Footwear', 'Furnishings', 'Toys', 'Diversified Retailers']
    },
    setFinance() {
      mixpanel.track('set filter', { name: 'Finance' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Banks', 'Consumer Finance', 'Financial Administration', 'Specialty Finance', 'Mortgage Finance', 'Asset Managers and Custodians', 'Life Insurance', 'Property and Casualty Insurance']
    },
    setAuto() {
      mixpanel.track('set filter', { name: 'Auto' })
      this.filter.search = ''
      this.filter.countries = []
      this.filter.sectors = ['Automobiles', 'Auto Parts', 'Auto Services']
    },
    setG7() {
      mixpanel.track('set filter', { name: 'G7' })
      this.filter.search = ''
      this.filter.sectors = []
      this.filter.countries = ['🇺🇸 USA', '🇯🇵 Japan', '🇬🇧 United Kingdom', '🇫🇷 France', '🇨🇦 Canada', '🇩🇪 Germany', '🇮🇹 Italy']
    },
    setBRICS() {
      mixpanel.track('set filter', { name: 'BRICS' })
      this.filter.search = ''
      this.filter.sectors = []
      this.filter.countries = ['🇧🇷 Brazil', '🇷🇺 Russia', '🇮🇳 India', '🇨🇳 China', '🇿🇦 South Africa']
    },
    setEU() {
      mixpanel.track('set filter', { name: 'EU' })
      this.filter.search = ''
      this.filter.sectors = []
      this.filter.countries = ['🇦🇹 Austria', '🇧🇪 Belgium', '🇨🇿 Czechia', '🇩🇰 Denmark', '🇫🇮 Finland', '🇫🇷 France', '🇩🇪 Germany', '🇬🇷 Greece', '🇭🇺 Hungary', '🇮🇪 Ireland', '🇱🇺 Luxembourg', '🇳🇱 Netherlands', '🇳🇴 Norway', '🇵🇱 Poland', '🇵🇹 Portugal', '🇪🇸 Spain', '🇬🇧 United Kingdom']
    },
    setAfricaAndME() {
      mixpanel.track('set filter', { name: 'AfricaAndME' })
      this.filter.search = ''
      this.filter.sectors = []
      this.filter.countries = ['🇪🇬 Egypt', '🇿🇦 South Africa', '🇮🇱 Israel', '🇶🇦 Qatar', '🇦🇪 United Arab Emirates']
    },
    setSEAsia() {
      mixpanel.track('set filter', { name: 'SEAsia' })
      this.filter.search = ''
      this.filter.sectors = []
      this.filter.countries = ['🇸🇬 Singapore', '🇹🇭 Thailand', '🇲🇾 Malaysia', '🇮🇩 Indonesia', '🇵🇭 Philippines']
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="sass">
.predefined_filters a
  white-space: nowrap
.multiselect__tag
  background: #f2f2f2
  color: black
.multiselect__clear
  position: absolute
  right: 41px
  height: 40px
  width: 40px
  display: block
  cursor: pointer
  z-index: 2
.multiselect__clear:after, .multiselect__clear:before
  content: ""
  display: block
  position: absolute
  width: 3px
  height: 16px
  background: #aaa
  top: 12px
  right: 4px
.multiselect__clear:before
  transform: rotate(45deg)
.multiselect__clear:after
  transform: rotate(-45deg)
</style>
